import { RecordMaskResource } from '@skinsoft/types'

/* tslint:disable:object-literal-sort-keys */

// tslint:disable-next-line:variable-name
export const archiveRecordMask: RecordMaskResource = {
    name: {
        translatedString: {
            fr: 'Masque Reporter',
        },
        translatedId: null,
    },
    categories: [
        {
            label: {
                translatedString: {
                    fr: 'Identification',
                    'fr-ca': 'Identification',
                    en: 'Identification',
                    'en-us': 'Identification',
                    nl: 'Identificatie',
                    es: 'Identificación',
                    it: 'Identificazione',
                    no: 'Identifikasjon',
                    de: 'Identifikation',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d64",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "identificationArchiveSchema",
                        "name": "cote",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "String"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationArchiveSchema.cote",
                        "pathType": "org.skinsoft.backend.schemas.archive.identificationarchiveschema.IdentificationArchiveSchema|java.lang.String",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1741791166975",
                        "backwardSearchEnable": false,
                        "intermediateSearchEnableParameter": [
                            {
                                "row": 0,
                                "column": 0,
                                "workspace": "",
                                "target": ""
                            }
                        ],
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: null,
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d76",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "identificationArchiveSchema",
                        "name": "descriptionLevel",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                            "type": "ThesaurusTerm",
                            "thesaurusIdentifier": "descriptionArchiveLevel"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationArchiveSchema.descriptionLevel",
                        "pathType": "org.skinsoft.backend.schemas.archive.identificationarchiveschema.IdentificationArchiveSchema|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132286",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '591ca0a7907aba0001ac69fe',
                        name: 'reference-title',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca2a7857aaa0001ac29de',
                        name: 'reference-input-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: null,
                    mandatoryUser: false,
                    order: 1,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d8a",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "linkArchiveSchema",
                        "name": "referentArchive",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ReferenceEntityFieldType",
                            "type": "Archive",
                            "subTypes": [],
                            "useTrueType": false
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "linkArchiveSchema.referentArchive",
                        "pathType": "org.skinsoft.backend.schemas.archive.linkarchiveschema.LinkArchiveSchema|org.skinsoft.backend.types.archive.Archive",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132312",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '591ca0a7907aba0001ac69fe',
                        name: 'reference-title',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca2a7857aaa0001ac29de',
                        name: 'reference-input-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: null,
                    mandatoryUser: false,
                    order: 2,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d71",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "identificationArchiveSchema",
                        "name": "titles",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "Title"
                            },
                            "listClass": "org.skinsoft.backend.schemas.archive.identificationarchiveschema.complex.Title"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationArchiveSchema.titles",
                        "pathType": "org.skinsoft.backend.schemas.archive.identificationarchiveschema.IdentificationArchiveSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1741791166993",
                        "backwardSearchEnable": false,
                        "intermediateSearchEnableParameter": [
                            {
                                "row": 0,
                                "column": 1,
                                "workspace": "",
                                "target": ""
                            }
                        ],
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d6b",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "identificationArchiveSchema",
                                "name": "title",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationArchiveSchema.titles.title",
                                "pathType": "org.skinsoft.backend.schemas.archive.identificationarchiveschema.IdentificationArchiveSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1E+10,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132274",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            mandatoryUser: false,
                            order: 3,
                            columnDisplay: true,
                            paginated: null,
                            entityFields: null,
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d6d",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "identificationArchiveSchema",
                                "name": "typeOfTitle",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationArchiveSchema.titles.typeOfTitle",
                                "pathType": "org.skinsoft.backend.schemas.archive.identificationarchiveschema.IdentificationArchiveSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132276",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            mandatoryUser: false,
                            order: 3,
                            columnDisplay: true,
                            paginated: null,
                            entityFields: null,
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                        }
                    ],
                    mandatoryUser: false,
                    order: 3,
                    columnDisplay: true,
                    paginated: null,
                },
            ],
        },
        {
            label: {
                translatedString: {
                    fr: 'Description',
                    'fr-ca': 'Description',
                    en: 'MISSING TRANSLATION',
                    'en-us': 'MISSING TRANSLATION',
                    nl: 'MISSING TRANSLATION',
                    es: 'MISSING TRANSLATION',
                    it: 'MISSING TRANSLATION',
                    no: 'MISSING TRANSLATION',
                    de: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9ce0",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "contentAndStructureArchiveSchema",
                        "name": "archiveType",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "ArchiveType"
                            },
                            "listClass": "org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.complex.ArchiveType"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "contentAndStructureArchiveSchema.archiveType",
                        "pathType": "org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.ContentAndStructureArchiveSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1741791166783",
                        "backwardSearchEnable": false,
                        "intermediateSearchEnableParameter": [
                            {
                                "row": 1,
                                "column": 0,
                                "workspace": "",
                                "target": ""
                            }
                        ],
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9cdc",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "contentAndStructureArchiveSchema",
                                "name": "archiveType",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "archiveType"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "contentAndStructureArchiveSchema.archiveType.archiveType",
                                "pathType": "org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.ContentAndStructureArchiveSchema|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132037",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        }
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d77",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "identificationArchiveSchema",
                        "name": "materialImportance",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "TranslatedString"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationArchiveSchema.materialImportance",
                        "pathType": "org.skinsoft.backend.schemas.archive.identificationarchiveschema.IdentificationArchiveSchema|org.skinsoft.backend.types.translatedstring.TranslatedString",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132287",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: null,
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d10",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "contentAndStructureArchiveSchema",
                        "name": "mediumTypeArchive",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "MediumTypeArchive"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "contentAndStructureArchiveSchema.mediumTypeArchive",
                        "pathType": "org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.ContentAndStructureArchiveSchema|org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.complex.MediumTypeArchive",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132099",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d0d",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "contentAndStructureArchiveSchema",
                                "name": "principalMediumType",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeOfMedium"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "contentAndStructureArchiveSchema.mediumTypeArchive.principalMediumType",
                                "pathType": "org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.ContentAndStructureArchiveSchema|org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.complex.MediumTypeArchive|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132096",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d0e",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "contentAndStructureArchiveSchema",
                                "name": "specificMediumTypes",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                        "type": "ThesaurusTerm",
                                        "thesaurusIdentifier": "typeOfMedium"
                                    }
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "contentAndStructureArchiveSchema.mediumTypeArchive.specificMediumTypes",
                                "pathType": "org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.ContentAndStructureArchiveSchema|org.skinsoft.backend.schemas.archive.contentandstructurearchiveschema.complex.MediumTypeArchive|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132097",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
            ],
        },
        {
            label: {
                translatedString: {
                    fr: 'Création',
                    'fr-ca': 'Création',
                    en: 'MISSING TRANSLATION',
                    'en-us': 'MISSING TRANSLATION',
                    nl: 'MISSING TRANSLATION',
                    es: 'MISSING TRANSLATION',
                    it: 'MISSING TRANSLATION',
                    no: 'MISSING TRANSLATION',
                    de: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d32",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "contextArchiveSchema",
                        "name": "productions",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "Production"
                            },
                            "listClass": "org.skinsoft.backend.schemas.archive.contextarchiveschema.complex.Production"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "contextArchiveSchema.productions",
                        "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1741791166880",
                        "backwardSearchEnable": false,
                        "intermediateSearchEnableParameter": [
                            {
                                "row": 1,
                                "column": 1,
                                "workspace": "",
                                "target": ""
                            }
                        ],
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d27",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "contextArchiveSchema",
                                "name": "producers",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "AssociatedAuthority"
                                    },
                                    "listClass": "org.skinsoft.backend.schemas.archive.common.AssociatedAuthority"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "contextArchiveSchema.productions.producers",
                                "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132133",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: [
                                {
                                    entityField: {
                                        entityFieldId: "5d4af517feac2254025b9d24",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "archive",
                                        "schema": "contextArchiveSchema",
                                        "name": "authorName",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ReferenceEntityFieldType",
                                            "type": "Alias",
                                            "subTypes": [],
                                            "filter": "595ca6a7857ababbc1abcd16",
                                            "isRestrictive": false,
                                            "esPath": "aliasSchema.tags.ref",
                                            "useTrueType": false
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "contextArchiveSchema.productions.producers.authorName",
                                        "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List|org.skinsoft.backend.types.alias.Alias",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523132129",
                                        "backwardSearchEnable": true,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    entityFields: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    columnDisplay: true,
                                    paginated: null,
                                },
                                {
                                    entityField: {
                                        entityFieldId: "5d4af517feac2254025b9d25",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "archive",
                                        "schema": "contextArchiveSchema",
                                        "name": "functions",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                            "type": "List",
                                            "entityFieldType": {
                                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                                "type": "ThesaurusTerm",
                                                "thesaurusIdentifier": "function"
                                            }
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "contextArchiveSchema.productions.producers.functions",
                                        "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List|java.util.List",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523132130",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    entityFields: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    columnDisplay: true,
                                    paginated: null,
                                },
                                {
                                    entityField: {
                                        entityFieldId: "5d4af517feac2254025b9d26",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "archive",
                                        "schema": "contextArchiveSchema",
                                        "name": "precision",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                            "type": "TranslatedString"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "contextArchiveSchema.productions.producers.precision",
                                        "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523132132",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    entityFields: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    columnDisplay: true,
                                    paginated: null,
                                },
                            ],
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d2a",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "contextArchiveSchema",
                                "name": "productionDates",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "DateArchive"
                                    },
                                    "listClass": "org.skinsoft.backend.schemas.archive.common.DateArchive"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "contextArchiveSchema.productions.productionDates",
                                "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132138",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: [
                                {
                                    entityField: {
                                        entityFieldId: "5d4af517feac2254025b9d28",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "archive",
                                        "schema": "contextArchiveSchema",
                                        "name": "date",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                            "type": "SkinDate"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "contextArchiveSchema.productions.productionDates.date",
                                        "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List|org.skinsoft.backend.types.date.SkinDate",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": false,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523132135",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    entityFields: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    columnDisplay: true,
                                    paginated: null,
                                },
                                {
                                    entityField: {
                                        entityFieldId: "5d4af517feac2254025b9d29",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "archive",
                                        "schema": "contextArchiveSchema",
                                        "name": "qualifierDate",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                            "type": "ThesaurusTerm",
                                            "thesaurusIdentifier": "qualifierDate"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "contextArchiveSchema.productions.productionDates.qualifierDate",
                                        "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523132136",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    entityFields: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    columnDisplay: true,
                                    paginated: null,
                                },
                            ],
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d30",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "contextArchiveSchema",
                                "name": "productionLocations",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "LocationArchive"
                                    },
                                    "listClass": "org.skinsoft.backend.schemas.archive.common.LocationArchive"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "contextArchiveSchema.productions.productionLocations",
                                "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132145",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: [
                                {
                                    entityField: {
                                        entityFieldId: "5d4af517feac2254025b9d2e",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "archive",
                                        "schema": "contextArchiveSchema",
                                        "name": "location",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                            "type": "ThesaurusTerm",
                                            "thesaurusIdentifier": "location"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "contextArchiveSchema.productions.productionLocations.location",
                                        "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523132143",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    entityFields: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    columnDisplay: true,
                                    paginated: null,
                                },
                                {
                                    entityField: {
                                        entityFieldId: "5d4af517feac2254025b9d2f",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "archive",
                                        "schema": "contextArchiveSchema",
                                        "name": "placeQualifier",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                            "type": "ThesaurusTerm",
                                            "thesaurusIdentifier": "placeQualifiers"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "contextArchiveSchema.productions.productionLocations.placeQualifier",
                                        "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523132144",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    entityFields: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    columnDisplay: true,
                                    paginated: null,
                                },
                            ],
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d31",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "contextArchiveSchema",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "contextArchiveSchema.productions.precision",
                                "pathType": "org.skinsoft.backend.schemas.archive.contextarchiveschema.ContextArchiveSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132146",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
            ],
        },
        {
            label: {
                translatedString: {
                    fr: 'État',
                    'fr-ca': 'État',
                    en: 'MISSING TRANSLATION',
                    'en-us': 'MISSING TRANSLATION',
                    nl: 'MISSING TRANSLATION',
                    es: 'MISSING TRANSLATION',
                    it: 'MISSING TRANSLATION',
                    no: 'MISSING TRANSLATION',
                    de: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    entityField: {
                        entityFieldId: "66cf0cce0817d610cec0e333",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "stateArchiveSchema",
                        "name": "currentItemStateArchive",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "CurrentItemStateArchive"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "stateArchiveSchema.currentItemStateArchive",
                        "pathType": "org.skinsoft.backend.schemas.archive.stateArchiveSchema.StateArchiveSchema|org.skinsoft.backend.schemas.archive.stateArchiveSchema.complex.CurrentItemStateArchive",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1725612720944",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "66cf0cce0817d610cec0e330",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "stateArchiveSchema",
                                "name": "currentState",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "stateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "stateArchiveSchema.currentItemStateArchive.currentState",
                                "pathType": "org.skinsoft.backend.schemas.archive.stateArchiveSchema.StateArchiveSchema|org.skinsoft.backend.schemas.archive.stateArchiveSchema.complex.CurrentItemStateArchive|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1725612720939",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "66cf0cce0817d610cec0e332",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "stateArchiveSchema",
                                "name": "dateHistory",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "SkinDate"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "stateArchiveSchema.currentItemStateArchive.dateHistory",
                                "pathType": "org.skinsoft.backend.schemas.archive.stateArchiveSchema.StateArchiveSchema|org.skinsoft.backend.schemas.archive.stateArchiveSchema.complex.CurrentItemStateArchive|org.skinsoft.backend.types.date.SkinDate",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1725612720943",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "66cf0cce0817d610cec0e331",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "stateArchiveSchema",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "stateArchiveSchema.currentItemStateArchive.precision",
                                "pathType": "org.skinsoft.backend.schemas.archive.stateArchiveSchema.StateArchiveSchema|org.skinsoft.backend.schemas.archive.stateArchiveSchema.complex.CurrentItemStateArchive|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1725612720941",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
            ],
        },
        {
            label: {
                translatedString: {
                    fr: 'Localisation',
                    'fr-ca': 'Localisation',
                    en: 'MISSING TRANSLATION',
                    'en-us': 'MISSING TRANSLATION',
                    nl: 'MISSING TRANSLATION',
                    es: 'MISSING TRANSLATION',
                    it: 'MISSING TRANSLATION',
                    no: 'MISSING TRANSLATION',
                    de: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d91",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "locationArchiveSchema",
                        "name": "permanentLocation",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "PermanentLocationArchive"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "locationArchiveSchema.permanentLocation",
                        "pathType": "org.skinsoft.backend.schemas.archive.locationarchiveschema.LocationArchiveSchema|org.skinsoft.backend.schemas.archive.locationarchiveschema.complex.PermanentLocationArchive",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132359",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d8f",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "locationArchiveSchema",
                                "name": "permanentLocation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ReferenceEntityFieldType",
                                    "type": "Location",
                                    "subTypes": [],
                                    "useTrueType": false
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "locationArchiveSchema.permanentLocation.permanentLocation",
                                "pathType": "org.skinsoft.backend.schemas.archive.locationarchiveschema.LocationArchiveSchema|org.skinsoft.backend.schemas.archive.locationarchiveschema.complex.PermanentLocationArchive|org.skinsoft.backend.types.location.Location",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132353",
                                "backwardSearchEnable": true,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d8e",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "locationArchiveSchema",
                                "name": "effectiveDate",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "SkinDate"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "locationArchiveSchema.permanentLocation.effectiveDate",
                                "pathType": "org.skinsoft.backend.schemas.archive.locationarchiveschema.LocationArchiveSchema|org.skinsoft.backend.schemas.archive.locationarchiveschema.complex.PermanentLocationArchive|org.skinsoft.backend.types.date.SkinDate",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132352",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "6435569c6c87701ff553b2ec",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "locationArchiveSchema",
                                "name": "occupiedSpace",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "Integer"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "locationArchiveSchema.permanentLocation.occupiedSpace",
                                "pathType": "org.skinsoft.backend.schemas.archive.locationarchiveschema.LocationArchiveSchema|org.skinsoft.backend.schemas.archive.locationarchiveschema.complex.PermanentLocationArchive|java.lang.Integer",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132355",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d9b",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "locationArchiveSchema",
                        "name": "realTimeLocation",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "RealTimeLocationArchive"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "locationArchiveSchema.realTimeLocation",
                        "pathType": "org.skinsoft.backend.schemas.archive.locationarchiveschema.LocationArchiveSchema|org.skinsoft.backend.schemas.archive.locationarchiveschema.complex.RealTimeLocationArchive",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132377",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d99",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "locationArchiveSchema",
                                "name": "realTimeLocation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ReferenceEntityFieldType",
                                    "type": "Location",
                                    "subTypes": [],
                                    "useTrueType": false
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "locationArchiveSchema.realTimeLocation.realTimeLocation",
                                "pathType": "org.skinsoft.backend.schemas.archive.locationarchiveschema.LocationArchiveSchema|org.skinsoft.backend.schemas.archive.locationarchiveschema.complex.RealTimeLocationArchive|org.skinsoft.backend.types.location.Location",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132373",
                                "backwardSearchEnable": true,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d98",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "locationArchiveSchema",
                                "name": "effectiveDate",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "SkinDate"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "locationArchiveSchema.realTimeLocation.effectiveDate",
                                "pathType": "org.skinsoft.backend.schemas.archive.locationarchiveschema.LocationArchiveSchema|org.skinsoft.backend.schemas.archive.locationarchiveschema.complex.RealTimeLocationArchive|org.skinsoft.backend.types.date.SkinDate",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132372",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "619e449174e9af364bcaae47",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "conditioningArchiveSchema",
                        "name": "actualContainer",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "ActualContainerArchive"
                            },
                            "listClass": "org.skinsoft.backend.schemas.archive.conditioningarchiveschema.complex.ActualContainerArchive"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditioningArchiveSchema.actualContainer",
                        "pathType": "org.skinsoft.backend.schemas.archive.conditioningarchiveschema.ConditioningArchiveSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523131986",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "619e449174e9af364bcaae45",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "conditioningArchiveSchema",
                                "name": "container",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ReferenceEntityFieldType",
                                    "type": "ContainerItem",
                                    "subTypes": [
                                        "NumericContainerItem",
                                        "PhysicalContainerItem"
                                    ],
                                    "useTrueType": false
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditioningArchiveSchema.actualContainer.container",
                                "pathType": "org.skinsoft.backend.schemas.archive.conditioningarchiveschema.ConditioningArchiveSchema|java.util.List|org.skinsoft.backend.types.item.containeritem.ContainerItem",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523131982",
                                "backwardSearchEnable": true,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
            ],
        },
        {
            label: {
                translatedString: {
                    fr: 'Notes',
                    'fr-ca': 'Notes',
                    en: 'MISSING TRANSLATION',
                    'en-us': 'MISSING TRANSLATION',
                    nl: 'MISSING TRANSLATION',
                    es: 'MISSING TRANSLATION',
                    it: 'MISSING TRANSLATION',
                    no: 'MISSING TRANSLATION',
                    de: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9d5a",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "descriptionArchiveSchema",
                        "name": "archivistNotes",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "ArchivistNote"
                            },
                            "listClass": "org.skinsoft.backend.schemas.archive.descriptionarchiveschema.complex.ArchivistNote"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "descriptionArchiveSchema.archivistNotes",
                        "pathType": "org.skinsoft.backend.schemas.archive.descriptionarchiveschema.DescriptionArchiveSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1741791166930",
                        "backwardSearchEnable": false,
                        "intermediateSearchEnableParameter": [
                            {
                                "row": 4,
                                "column": 0,
                                "workspace": "",
                                "target": ""
                            }
                        ],
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9d58",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "descriptionArchiveSchema",
                                "name": "note",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "descriptionArchiveSchema.archivistNotes.note",
                                "pathType": "org.skinsoft.backend.schemas.archive.descriptionarchiveschema.DescriptionArchiveSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132212",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9dac",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "locationArchiveSchema",
                        "name": "locationNotes",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "TranslatedString"
                            }
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "locationArchiveSchema.locationNotes",
                        "pathType": "org.skinsoft.backend.schemas.archive.locationarchiveschema.LocationArchiveSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132401",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: null,
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "5d4af517feac2254025b9cdb",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "conservationArchiveSchema",
                        "name": "conservationNote",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "ConservationNoteArchive"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conservationArchiveSchema.conservationNote",
                        "pathType": "org.skinsoft.backend.schemas.archive.conservationarchiveschema.ConservationArchiveSchema|org.skinsoft.backend.schemas.archive.conservationarchiveschema.complex.ConservationNoteArchive",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132031",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "5d4af517feac2254025b9cda",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "conservationArchiveSchema",
                                "name": "note",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": false,
                                "path": "conservationArchiveSchema.conservationNote.note",
                                "pathType": "org.skinsoft.backend.schemas.archive.conservationarchiveschema.ConservationArchiveSchema|org.skinsoft.backend.schemas.archive.conservationarchiveschema.complex.ConservationNoteArchive|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132030",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
                {
                    entityField: {
                        entityFieldId: "637e3f0cb43e8d5be2970deb",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "archive",
                        "schema": "archiveSafetyPlanSchema",
                        "name": "notes",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "ArchiveSafetyPlanNote"
                            },
                            "listClass": "org.skinsoft.backend.schemas.archive.ArchiveSafetyPlanSchema.complex.ArchiveSafetyPlanNote"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "archiveSafetyPlanSchema.notes",
                        "pathType": "org.skinsoft.backend.schemas.archive.ArchiveSafetyPlanSchema.ArchiveSafetyPlanSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523132542",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    fieldFormat: {
                        id: '595ca6a7907aba0001ac69fe',
                        name: 'text',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca6a7857aaa0001ac68db',
                        name: 'text-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "637e3f0cb43e8d5be2970dea",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "archive",
                                "schema": "archiveSafetyPlanSchema",
                                "name": "note",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "archiveSafetyPlanSchema.notes.note",
                                "pathType": "org.skinsoft.backend.schemas.archive.ArchiveSafetyPlanSchema.ArchiveSafetyPlanSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523132541",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            entityFields: null,
                            mandatoryUser: false,
                            order: 0,
                            columnDisplay: true,
                            paginated: null,
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    columnDisplay: true,
                    paginated: null,
                },
            ],
        },
    ],
    level: 'adminLevel',
    userId: '595ca6a7857aba0001a00001',
    entityTargetId: '736bb6b8857abf0001ac9888',
    entityTarget: 'recolement',
    isInputMask: true,
    categoriesDisplay: true,
    workspaceCreation: '5d6917c3fb6ee95ed082f268',
    workspaceSharing: [],
    isPatternMask: false,
    pattern: null,
    _links: {
        self: {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650',
        },
        'record-masks': {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650',
        },
        'mask-fields': {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650/mask-fields',
        },
    },
    id: '6070579b0a6d211f1520a650',
}
